<mat-card class="example-card">
  <mat-card-header
    class="titreFrm items-center justify-center"
    style="padding: 2em 0em !important"
  >
    <mat-card-title>Rapport visite client</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>

    <div
      *ngIf="CRM_DS && !refrech"
      class="grid gap-x-4 p-8 w-full grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
      style="overflow: auto"
    >
      <form (ngSubmit)="enregistrer()" class="contents">
        <div class="col-span-2">
          <mat-form-field appearance="outline">
            <mat-label>Date Visite : </mat-label>
            <input
              [(ngModel)]="CRM_DS.CRMActivity[0].CRMActivity_Date"
              [ngModelOptions]="{ standalone: true }"
              matInput
              required
              [matDatepicker]="dateDebut"
              placeholder="Date Visite"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dateDebut"
            ></mat-datepicker-toggle>
            <mat-datepicker #dateDebut></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-span-1">
          <button
            mat-flat-button
            type="submit"
            class="bg-green-600 text-white float-right text-xl px-16 py-8"
          >
            Enregistrer
          </button>
        </div>
        <div>
          <label>Client</label>
          <app-recherche
            appearance="outline"
            champsModel="Tiers_code"
            champsAffiche="Tiers_RS"
            textErreur="Veuillez Entrer un tier valide"
            recherche="Tier"
            [api]="generalService.api"
            placeholder="Client"
            [(ngModel)]="client.Tiers_code"
            [ngModelOptions]="{ standalone: true }"
            (ChampEnter)="ChampEnter()"
            (ChampBlur)="clientBlur()"
          >
          </app-recherche>
        </div>
        <div class="flex flex-col">
          <label>Adresse</label>
          <mat-form-field appearance="outline">
            <input
              name="adresse"
              matInput
              placeholder="Adresse"
              [(ngModel)]="this.client.Tiers_Adresse"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </div>
        <div class="flex flex-col">
          <label>Contact</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="Contact"
              [(ngModel)]="this.client.Tiers_Contact_Nom"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </div>
        <div class="flex flex-col">
          <label>Email</label>
          <mat-form-field appearance="outline">
            <input
              name="email"
              matInput
              placeholder="Email"
              [(ngModel)]="this.client.Tiers_Contact_mail"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </div>
        <div class="flex flex-col">
          <label>Tél</label>
          <mat-form-field appearance="outline">
            <input
              name="tel"
              matInput
              placeholder="Tél"
              [(ngModel)]="this.client.Tiers_Contact_Tel"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </div>
        <hr class="col-span-3 mx-12 mb-12" />
        <!-- <div class="flex flex-col">
          <label>Position</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="Position"
              [(ngModel)]="CRM_DS.CRMActivity.XCRMActivity_Potentiel"
              [ngModelOptions]="{standalone: true}"
            />
          </mat-form-field>
        </div> -->
        <div class="flex flex-col">
          <label>Activité</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              required
              placeholder="Activité"
              [(ngModel)]="CRM_DS.CRMActivity[0].CRMActivity_Titre"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </div>
        <div class="flex flex-col">
          <label>Potentiel client</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="Potentiel client"
              [(ngModel)]="CRM_DS.CRMActivity[0].XCRMActivity_Potentiel"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </div>
        <div class="flex flex-col">
          <label>Gamme vendue</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="Gamme vendue"
              [(ngModel)]="CRM_DS.CRMActivity[0].XCRMActivity_GammeVendue"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </div>
        <div class="flex flex-col">
          <label>Concurrents présents</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="Concurrents présents"
              [(ngModel)]="CRM_DS.CRMActivity[0].XCRMActivity_Concurrents"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </div>
        <div class="flex flex-col">
          <label>Potentiel par catégorie située</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="Potentiel par catégorie située"
              [(ngModel)]="CRM_DS.CRMActivity[0].XCRMActivity_Potentielparcat"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </div>
        <div class="flex flex-col">
          <label>Gamme proposée</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="Gamme proposée"
              [(ngModel)]="CRM_DS.CRMActivity[0].XCRMActivity_Gammeprop"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </div>
        <div class="flex flex-col">
          <label>Feedback visite</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="Feedback visite"
              [(ngModel)]="CRM_DS.CRMActivity[0].XCRMActivity_feedback"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </div>
        <div class="flex flex-col">
          <label>Prochaine étape</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="Prochaine étape"
              [(ngModel)]="CRM_DS.CRMActivity[0].XCRMActivity_Prochaineetape"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </div>
        <div class="flex flex-col">
          <label>Taux d'avancement</label>
          <mat-slider
            [(ngModel)]="CRM_DS.CRMActivity[0].XCRMActivity_TauxAvancement"
            [ngModelOptions]="{ standalone: true }"
            class="mt-4"
            min="0"
            max="100"
            step="10"
            value="0"
            thumbLabel
            tickInterval="1"
          ></mat-slider>
        </div>
      </form>
    </div>
  </mat-card-content>
</mat-card>
